/** @internal */
export function deprecatedWarn(message: string): void {
  console.warn(`DEPRECATED WARN: ${message}`);
}
